<template>
  <div class="detail">
    <div class="basic-detail">
      <div class="title">{{pdetail.title}}</div>
      <div class="content">
        <div class="img">
          <img :src="images[pdetail.id]">
        </div>
        <div>
          <div class="mb30">
            <span class="money">{{pdetail.money}}</span>
            <span class="unit">元/人/年</span>
          </div>
          <div class="mb15">
            <img class="icon mr15" src="../../../images/icon_term@2x.png">
            <span>保障期限： 一年</span>
          </div>
          <div class="mb15">
            <img class="icon mr15" src="../../../images/icon_pay@2x.png">
            <span>缴费方式：</span>
            <span class="checkbox" :class="{'active': isChecked}" @click="toggleChecked">年缴</span>
          </div>
          <div>
            <span class="tip">* 具体请以客服实际报价为准</span>
          </div>
          <div class="btn-row">
            <span class="btn" @click="previewDetail">我要咨询</span>
          </div>
        </div>
      </div>
    </div>
    <div class="product-detail">
      <div class="title">产品详情</div>
      <a-table :columns="detailColumns" :dataSource="detailTable" bordered :pagination="false">
      </a-table>
    </div>
    <div class="service-content">
      <div class="title">服务内容</div>
      <a-table :columns="serviceColumns" :dataSource="serviceTable" bordered :pagination="false">
      </a-table>
    </div>
    <v-modal :visible="visible" @onCloseModal="handleCloseModal"></v-modal>     
  </div>
</template>

<script>
import axios from 'axios'
import vModal from '@/components/modal/index.vue'

export default {
  components: {
    vModal,
  },
  data () {
    return {
      visible: false,
      isChecked: true,
      images: [
        '',
        require('../../../images/p_normalA@2x.png'),
        require('../../../images/p_normalB@2x.png'),
        require('../../../images/p_normalC@2x.png'),
        require('../../../images/p_selectedA@2x.png'),
        require('../../../images/p_selectedB@2x.png'),
        require('../../../images/p_selectedC@2x.png'),
      ],
      pdetail: {},
      detailTable: [],
      serviceTable: [],
      detailColumns: [
        {
          title: '保障类型',
          dataIndex: 'type',
          width: 180,
          align: 'center',
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if (index === 0) {
              obj.attrs.rowSpan = 4
            } else if (index === 4) {
              obj.attrs.rowSpan = 3
            } else {
              obj.attrs.rowSpan = 0
            }
            return obj;
          },
        },
        {
          title: '保障险种',
          dataIndex: 'insurance',
          width: 210,
          align: 'center',
        },
        {
          title: '保障内容',
          dataIndex: 'content',
          width: 510,
          align: 'center',
        },
        {
          title: '理赔方案',
          dataIndex: 'programme',
          width: 180,
          align: 'center',
        }
      ],
      serviceColumns: [
        {
          title: '服务分类',
          dataIndex: 'name',
          width: 270,
          align: 'center',
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if (index === 0) {
              obj.attrs.rowSpan = 9
            } else if (index === 9) {
              obj.attrs.rowSpan = 9
            } else if (index === 18) {
              obj.attrs.rowSpan = 3
            } else if (index === 21) {
              obj.attrs.rowSpan = 9
            } else if (index === 30) {
              obj.attrs.rowSpan = 9
            } else {
              obj.attrs.rowSpan = 0
            }
            return obj;
          },
        },
        {
          title: '服务名称',
          dataIndex: 'title',
          width: 570,
          align: 'center',
        },
        {
          title: '服务内容',
          dataIndex: 'content',
          width: 270,
          align: 'center',
        }
      ],
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      axios.get('../../../data-list.json').then(res => {
        const id = this.$route.params.id
        const data = res.data.filter(item => item.id === id)
        this.pdetail = data[0]
        data[0].list.map((item, index) => {
          item.key = index
        })
        this.detailTable = data[0].list
        this.getService()
      })
    },
    getService () {
      const type = this.pdetail.type
      axios.get('../../../data-service.json').then(res => {
        const data = res.data.filter(item => item.type === type)
        data[0].list.map((item, index) => {
          item.key = index
        })
        this.serviceTable = data[0].list
      })
    },
    toggleChecked () {
      this.isChecked = !this.isChecked
    },
    previewDetail () {
      this.visible = true
    },
    handleCloseModal (val) {
      this.visible = val
    }
  }
}
</script>

<style lang="scss" scoped>
$padding: 35px 40px; 
@mixin title {
  margin-bottom: 37px;
  padding-bottom: 29px;
  font-family: DF King Gothic SC24;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
@mixin box-model {
  padding: $padding;
  width: 100%;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(78,132,248,0.08);

  .title {
    @include title;
  }
}

.detail {
  margin: 0 auto;
  width: 1160px;

  .basic-detail {
    margin-top: 58px;
    font-size: 22px;
    @include box-model;

    .content {
      display: flex;
      padding: 6px 0;
      font-size: 16px;
      font-family: Kozuka Gothic Pr6N;
      font-weight: normal;
      color: #333;

      .img {
        margin-right: 32px;

        img {
          width: 446px;
          height: 302px;
        }
      }

      .money {
        margin-right: 19px;
        font-family: Avenir Next;
        font-size: 34px;
        font-weight: 500;
        color: #F76D32;
      }

      .unit {
        font-size: 16px;
        font-family: Kozuka Gothic Pr6N;
        font-weight: normal;
        color: #333;
      }

      .checkbox {
        display: inline-block;
        width: 74px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: 1px solid #F87942;
        border-radius: 5px;
        cursor: pointer;

        &.active {
          border: 1px solid transparent;
          background-image: url(../../../images/checkbox@2x.png);
          background-repeat: no-repeat;
          background-size: cover;
        }
      }

      .tip {
        font-family: DF King Gothic SC24;
        font-size: 14px;
        font-weight: 500;
        color: #F87942;
      }

      .btn-row {
        margin-top: 55px;

        .btn {
          display: block;
          width: 120px;
          height: 48px;
          line-height: 48px;
          color: #fff;
          background: #F87942;
          text-align: center;
          border-radius: 25px;
          cursor: pointer;
        }
      }

      .icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .product-detail {
    margin-top: 31px;
    font-size: 18px;
    @include box-model;

    /deep/ .ant-table {
      font-size: 14px;
    }
    /deep/ .ant-table-thead > tr > th {
      background: #EFF1F3;
    }
  }

  .service-content {
    margin-top: 31px;
    margin-bottom: 130px;
    font-size: 18px;
    @include box-model;
    
    /deep/ .ant-table {
      font-size: 14px;
    }
    /deep/ .ant-table-thead > tr > th {
      background: #EFF1F3;
    }
  }

  /deep/ .ant-table-row-cell-break-word {
    white-space: pre;
  }
}

</style>